import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { setSearchResult } from '../utils/searchSlice';
import { RootState } from '../store/store';
import { FleetInfo, GlobalSearchResponse } from 'ais-facade-api/api';
import { BASE_URL } from 'app/utils/utils';
import i18next from 'i18next';
import { onQueryStartedErrorToast } from './apiErrorHandler';

export const searchApi = createApi({
  reducerPath: 'search',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL + '/facade/versions/1/',
    credentials: 'include',
    mode: 'cors',
    prepareHeaders: (headers: Headers, { getState }) => {
      const userInfo = (getState() as RootState).userSlice;
      headers.set('Accept-Language', i18next.resolvedLanguage ? i18next.resolvedLanguage : 'ru');

      if (userInfo.auth && userInfo.user) {
        headers.set('x-ais-user-csrf', userInfo.auth.value.csrfToken);
        headers.set('ais-user-csrf', userInfo.auth.value.csrfToken);
      }
      return headers;
    },
  }),
  tagTypes: ['Search'],
  endpoints: (build) => ({
    querySearch: build.query<GlobalSearchResponse, string>({
      query: (query) => ({
        url: `search?term=${query.replace(/ /g, '%20').replace(/\//g, '%2F')}`,
        withCredentials: true,
        transformResponse: (result: { data: { searchResult: FleetInfo[] } }) => result.data.searchResult,
        invalidatesTags: ['Search'],
        async onQueryStarted({ dispatch, queryFulfilled }: unknown) {
          try {
            const { data } = await queryFulfilled;
            dispatch(setSearchResult(data));
          } catch (error) {
            console.warn(error);
          }
        },
      }),
      onQueryStarted: onQueryStartedErrorToast,
    }),
  }),
});

export const { useLazyQuerySearchQuery } = searchApi;
